import _ from 'lodash'
import { emptyStringAsUndefined } from '../utils/strings';

export type AgentType = 'company' | 'person'

export type Agent = {
    agentType: AgentType;
    agentId?: number;
    firstName?: string;
    lastName?: string;
    name?: string;
}

export type AgentLink = {
    linkType: string;
    familyMemberId: number;
    agentType: AgentType;
    agentId: number;
}

export function isEqualAgentLink(a: AgentLink, b: AgentLink) {
    return a.linkType === b.linkType && 
        a.familyMemberId === b.familyMemberId && 
        //a.agentType === b.agentType && 
        a.agentId === b.agentId
}

export function nameOf(agent: Agent) {
    if (!agent) return undefined
    return agent.agentType === "company"
        ? agent.name
        : `${agent.firstName} ${agent.lastName}`
}

export function splitCompanyName(agent: Agent) {
    const parts = agent.name.split(' ')
    return { firstName: parts[0], lastName: parts.slice(1).join(' ')}
}

export function createAgentsLookup(agentLinks: AgentLink[]): Record<string, Record<number, number[]>> {
    return  _(agentLinks)
        .groupBy(l => l.linkType)
        .mapValues(ls => _(ls)
            .groupBy(l => l.agentId)
            .mapValues(vs => vs.map(v => v.familyMemberId))
            .value())
        .value()
}

export function createAgentsByMemberId(agentLinks: AgentLink[], agentById: Record<number, Agent>): Record<string, Record<number, number[]>> {
    return _(agentLinks)
        .groupBy(l => l.linkType)
        .mapValues(ls => _(ls)
            .groupBy(l => l.familyMemberId)
            .mapValues(vs => vs.map(v => v.agentId).filter(a => agentById[a]))
            .value())
        .value()
}

export function asPerson(name?: string): Agent | undefined {
    const names = name?.trim()?.split(' ')?.filter(w => w !== '')
    if (names?.length === 2) {
        return { agentType: 'person', firstName: names[0], lastName: names[1] }
    } else {
        return undefined
    }
}

export function asCompany(_name?: string): Agent | undefined {
    const name = emptyStringAsUndefined(_name?.trim())
    if (name) {
        return { agentType: 'company', name }
    } else {
        return undefined
    }
}

export function extractAgents(linkType: string, memberId: number, agentsByMemberId: Record<string, Record<number, number[]>>, agentById: Record<number, Agent>): number[] {
    const fullData = _(agentsByMemberId[linkType]?.[memberId] ?? [])
        .map(a => {
            const agent = agentById[a]
            const name = nameOf(agent)
            const sort = `${agent.agentType === 'person' ? '0' : '1'}-${name.toLocaleLowerCase()}`
            return { ...agent, name, sort }
        })
        .sortBy('sort')
        .value()
    return fullData.map(a => a.agentId)
}

export function isEquivalentAgent(a: Agent, b: Agent) {
    if (a.agentType === "person" && b.agentType === "person")
        return a.firstName === b.firstName && a.lastName === b.lastName
    else if (a.agentType === "company" && b.agentType === "company")
        return a.name === b.name
    else
        return false
}